import React from 'react';
import pages from "../../../scripts/myga-ui";
import Resources from "../../../Resources/Resources";
import {PAGES} from "../../../scripts/constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {MM_PRODUCT_VISUALS} from "../../../scripts/myga-model";
import PopoverTooltip from "../../../components/PopoverTooltip";

class AppPageHeader extends React.Component{

  headerId;
  headerLabel;

  pageBtnClicked = (nextPage) => {
    this.props.updatePage(nextPage);
  };

  render() {
    let headerClasses = (this.props.fullPage) ? 'full-page-header-corners' : 'page-header-corners';
    return (
      <div id={this.props.headerId}
           className={`col ${headerClasses}`}
           style={{
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'space-between',
             paddingLeft: '1em',
             paddingRight: '1em'
           }}>
        <div>
          {this.props.headerLabel}
          {
              this.props.headerInfo && (
                  <>
                    &nbsp;&nbsp;
                    <PopoverTooltip content={this.props.headerInfo}/>
                  </>
              )
          }
        </div>
        {(this.props.fullPage &&
            <div>
              <FontAwesomeIcon icon={'times'} style={{cursor: 'pointer', position: 'relative'}}
                               onClick={() => this.pageBtnClicked(PAGES.pageDashboard)}/>
            </div>
        )}
      </div>
    );
  }

}

export default AppPageHeader;